var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"todoapp"},[_c('Header'),_c('TodoList'),_c('Footer')],1),_c('Colophon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }